import { CustomError } from '@/domain/custom-error';

export class MetricsError extends CustomError {
	name = 'MetricsError';
	description = 'Error sending metric';
}
